import { Modal } from 'react-bootstrap';
import { formatText } from 'core/i18n';
import React from 'react';
import { getFormattedTimeLeft } from 'components/sessionTimeOut/SessionTimeoutModal/utils/getFormattedTimeLeft';
import { useTimeLeftCountDown } from 'components/sessionTimeOut/SessionTimeoutModal/hooks/useTimeLeftCountDown';
import { useRecordPage } from 'components/sessionTimeOut/SessionTimeoutModal/hooks/useRecordPage';

export const SessionTimeoutModal = ({
    showModal,
    modalClass,
    sessionStatus,
    userProfile,
    productsDescription,
    onClickSignOut,
    onClickContinue,
    onTimeExpiration,
    onHide,
}) => {
    useRecordPage({ showModal, userProfile, productsDescription });
    const { minLeft, secLeft } = useTimeLeftCountDown({
        showModal,
        initialMin: sessionStatus.get('minLeft'),
        initialSec: sessionStatus.get('secLeft'),
        onTimeExpiration,
    });

    const formattedTimeLeft = getFormattedTimeLeft({ minLeft, secLeft });

    return (
        <div>
            <Modal
                show={showModal}
                onHide={onHide}
                dialogClassName={modalClass}
                backdrop="static"
                keyboard={false}
                animation={false}
            >
                <Modal.Body>
                    <h5 className="font-heading5">{formatText('session-sessionTimeOutTitle')}</h5>
                    <div className="icon-container expired-Message">
                        <i className="icons icons--icon-time"></i>
                        <h2 className="font-heading2">{formattedTimeLeft}</h2>
                    </div>
                    <p className="font-paragraph2">{formatText('session-TimeOutMessage')}</p>
                    <div className="form__buttons">
                        <button className="form__button form__button-clean" onClick={onClickSignOut}>
                            {formatText('button-signOff')}
                        </button>
                        <button className="form__button form__button-secondary" onClick={onClickContinue}>
                            {formatText('button-continue')}
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
};
